import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface PawState {
  pawData: {
    answer: string;
  } | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: PawState = {
  pawData: null,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'paw',
  initialState,
  reducers: {
    setPawData(state, action) {
      state.pawData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setPawData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setPawData, setTitle };

export const selectPawData = (state: State) => state[name].pawData;
export const selectIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectPawTitle = (state: State) => state[name].title;
